export { EDITOR_TYPE, TextEditor } from "./textEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/textEditor/index.mjs
// module id = 156
// module chunks = 1